import QRScanner from './QRScanner';

export default QRScanner;
